import { useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { useTexture } from "@react-three/drei";
import * as THREE from "three";
import skydomeTextureSrc from "../../assets/images/day-xr-skydome-kloppenheim.jpg";
import useFogControlStore from "../../state/fogControls";

const SKYDOME_FADE_DURATION = 0.56;

export default function DayXrEnvironment({
  radius = 220,
  mode = "day",
  renderSkydome = true,
}) {
  const skydomeTexture = useTexture(skydomeTextureSrc);
  const sceneLighting = useFogControlStore((state) => state.sceneLighting);
  const materialRef = useRef();

  useEffect(() => {
    skydomeTexture.encoding = THREE.sRGBEncoding;
    skydomeTexture.anisotropy = 8;
    skydomeTexture.needsUpdate = true;
  }, [skydomeTexture]);

  useEffect(() => {
    if (!materialRef.current) return;
    materialRef.current.opacity = mode === "day" ? 1 : 0;
  }, []);

  useFrame((_, delta) => {
    if (!materialRef.current) return;

    const targetOpacity = mode === "day" ? 1 : 0;
    const currentOpacity = materialRef.current.opacity;

    if (Math.abs(currentOpacity - targetOpacity) < 0.001) {
      materialRef.current.opacity = targetOpacity;
      return;
    }

    const step = delta / SKYDOME_FADE_DURATION;
    materialRef.current.opacity = THREE.MathUtils.lerp(
      currentOpacity,
      targetOpacity,
      step
    );
  });

  if (!renderSkydome) {
    return null;
  }

  return (
    <>
      <group rotation={[0, (-5 * Math.PI) / 180, 0]}>
        <mesh scale={radius} frustumCulled={false}>
          <sphereGeometry args={[1, 64, 64]} />
          <meshBasicMaterial
            ref={materialRef}
            map={skydomeTexture}
            side={THREE.BackSide}
            toneMapped={false}
            transparent
            opacity={mode === "day" ? 1 : 0}
            color={new THREE.Color().setScalar(
              sceneLighting.skydomeBrightness
            )}
          />
        </mesh>
      </group>
    </>
  );
}
